<template>
  <div class="UI">
    <Form @request="submit" style="row-gap: 10px">
      <VInput required name="requiredProperty" />
      <VSelect
        required
        name="select"
        placeholder="placeholder"
        :items="[1, 2, 3, 4]"
      />
      <Checkbox name="checkbox" required />

      <div style="display: flex; column-gap: 10px">
        <Button
          icon="attach"
          iconWidth="14px"
          width="150px"
          height="32px"
          text="submit"
          class="btn-primary"
        />
        <Button
          @click.native.prevent="() => {}"
          width="150px"
          height="32px"
          icon="add"
          iconWidth="24px"
          text="not submit"
          class="btn-secondary"
        />
      </div>
    </Form>

    <Button
      @click="callReject"
      width="150px"
      height="32px"
      icon="add"
      iconWidth="24px"
      text="call PopUp"
      class="btn-outline-primary"
    />

    <VSwitch v-model="switchValue" />

    <AccountBadge />

    <Swiper :slides="[1, 2, 3, 4, 5, 6]" style="height: 100px">
      <template slot="item" slot-scope="{ item }">
        <VStatus :status="new Status(++item.index)" />
      </template>
    </Swiper>

    <VFile :value="new File(['foo'], 'foo.txt', { type: 'text/plain' })" />
    <VFiledrop />
    <Preloader />

    <Popup
      view="alert"
      title="С заголовком"
      text="Важное предупреждение или ошибка"
      style="bottom: 244.2px"
    />
    <Popup style="bottom: 168.2px" />
    <Popup type="info" title="Внимание" style="bottom: 94.2px" />
    <Popup v-if="false" type="success" title="Успех" text="текс" />
  </div>
</template>

<script>
import Form from "@/components/Form/Form.vue";
import VInput from "@/components/Form/Vinput/Vinput.vue";
import VSelect from "@/components/Form/VSelect.vue";
import Checkbox from "@/components/Form/Checkbox.vue";
import Button from "@/components/Button.vue";
import AccountBadge from "@/components/AccountBadge.vue";
import VStatus from "@/components/VStatus.vue";
import VSwitch from "@/components/VSwitch.vue";
import Popup from "@/components/Popup.vue";
import Preloader from "@/components/Preloader.vue";
import Swiper from "@/components/Swiper.vue";
import VFile from "@/components/VFile.vue";
import VFiledrop from "@/components/VFiledrop.vue";

class Status {
  constructor(id = 1, name = "Название статуса") {
    this.id = id;
    this.name = name;
  }
}

export default {
  components: {
    Form,
    VInput,
    VSelect,
    Checkbox,
    Button,
    AccountBadge,
    VStatus,
    VSwitch,
    Popup,
    Preloader,
    Swiper,
    VFile,
    VFiledrop,
  },
  data() {
    return {
      Status,
      File,
      switchValue: false,
    };
  },
  methods: {
    submit(data) {
      alert(JSON.stringify(data, null, 4));
    },
    callReject() {
      this.$root.popup('заголовок', 'текст', 'error', 'alert')
    },
  },
};
</script>

<style lang="scss" scoped>
.UI {
  display: grid;
  row-gap: 20px;
  margin: 20px 0;

  .item {
    display: flex;
    column-gap: 10px;
  }
}
</style>
